import { API_BASE_URL } from '../config';

const AVATAR_SIZES = Object.freeze({ xs: 32, sm: 64, md: 96, lg: 160, profile: 256 });

export function getAvatarVariantUrl(user = {}, variant = 'sm') {
  const userId = user?._id || user?.id || user?.user_id;
  const original = user?.avatar_url || user?.avatarUrl || null;
  const size = AVATAR_SIZES[variant];
  if (!userId || !original || !size) return original;
  return `${API_BASE_URL}/api/users/${encodeURIComponent(String(userId))}/avatar/${size}?v=${encodeURIComponent(original)}&format=full-v2`;
}

// Maps an on-screen pixel size to the smallest cached variant that still
// covers it, for surfaces that size their avatar at render time rather than
// through a fixed CSS class (e.g. a `size` prop).
export function avatarVariantForPixelSize(pixelSize) {
  const target = Number(pixelSize) || 0;
  const variant = Object.entries(AVATAR_SIZES).find(([, size]) => size >= target);
  return variant ? variant[0] : 'profile';
}

export { AVATAR_SIZES };
